import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=a7e4c964&scoped=true&"
import script from "./verificationList.vue?vue&type=script&lang=js&"
export * from "./verificationList.vue?vue&type=script&lang=js&"
import style0 from "./verificationList.vue?vue&type=style&index=0&id=a7e4c964&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e4c964",
  null
  
)

export default component.exports